import { render, staticRenderFns } from "./screen.vue?vue&type=template&id=3539fdfd&scoped=true"
import script from "./screen.vue?vue&type=script&lang=js"
export * from "./screen.vue?vue&type=script&lang=js"
import style0 from "./screen.vue?vue&type=style&index=0&id=3539fdfd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3539fdfd",
  null
  
)

export default component.exports